module.exports = __webpack_public_path__ + "static/media/producthunt.054e69ea.svg";